module.exports = __webpack_public_path__ + "img/olduserbg.aff11b26.png";